import { Subject, Subscription } from 'rxjs';
import {
  Component,
  OnInit,
  ElementRef,
  Input,
  OnDestroy,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import * as c3 from 'c3';
import { DataAnalyticsHelperService, DeliveredQtyCostPercentModel } from '../../services/data-analytics-helper.service';
import { DataAnalyticsService } from '../../services/data-analytics.service';
import { MatDialog } from '@angular/material/dialog';
import { BarLineComboChartPopupComponent } from './bar-line-combo-chart-popup/combo-chart-popup.component';
import { takeUntil } from 'rxjs/operators';
const monthnames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
@Component({
  selector: 'app-bar-line-combo-chart',
  templateUrl: './bar-line-combo-chart.component.html',
  styleUrls: ['./bar-line-combo-chart.component.scss']
})

export class BarLineComboChartComponent implements OnInit, OnDestroy {
  @Input() factorySummary: any;
  @Input() currentDate: string;
  @Input() currrentFilter: string;
  data: any = {
    barData: [],
    lineData: [],
    xAxisLabels: []
  };
  unit: string;
  // chartLabels: any = {
  //   x: null,
  //   y: null,
  //   y2: null
  // };
  colorList = ['#D26999', '#8F82C7'];
  lineId: string;
  subscription: Subscription;
  isLoading = false;
  message: string;
  public oneDate: any;
  public monthName: any;
  currentEndWeek: any;
  emitDataList: any;
  xAxixValueData;
  deliveredQty;
  costPercent;
  public divisionNumber = 1;
  public signType = '';
  deliveredQuantitySubscription: Subscription;

  constructor(
    private elRef: ElementRef,
    private helper: DataAnalyticsHelperService,
    private requester: DataAnalyticsService,
    private route: ActivatedRoute,
    public dialog: MatDialog
  ) { }

  ngOnInit() {
    this.subscription = this.route.queryParams.subscribe(params => {
      if (params.level && params.factory && params.level && params.level === 'line') {
        // check if not empty
        this.lineId = (params.LineId) ? params.LineId : null;
        this.getChartData();
      }
    });


    // this.chartLabels=this.helper.setLabels('deliveredQtyVsCostLine');
  }

  getLocalStorageData(key: string) {
    return JSON.parse(sessionStorage.getItem(key));
  }

  getChartData() {
    const daDate = this.getLocalStorageData('selectedDATimeFilter');
    this.isLoading = true;
    this.message = 'Loading...';
    this.unit = '-';
    const req = {
      FromDate: this.factorySummary.fromDate,
      ToDate: this.factorySummary.toDate,
      FactoryId: this.factorySummary.factoryId,
      LineId: this.lineId,
      Level: 'line',
    };
    const selectedHourDetail = {};
    this.currentEndWeek = '';
    // const startOfMonth = moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD');
    // const endOfMonth = moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD');
    this.emitDataList = {
      appliedFilterType: daDate ? daDate.appliedFilterType : '',
      dateObj: new Date(this.factorySummary.fromDate),
      selectedHr: selectedHourDetail,
      endWeekFromSelectedDate: this.currentEndWeek,
      startQuarterMonth: null
    };
    this.oneDate = this.emitDataList.dateObj;
    this.monthName = this.oneDate.toLocaleString('en-us', { month: 'short' });
    this.deliveredQuantitySubscription = this.requester.getDeliveredQuantity(req)
      .subscribe((res: DeliveredQtyCostPercentModel[]) => {
        if (res && res.length) {
          const distinctUnit: string[] = res.map(resValue => resValue.deliveredQtyUnit).filter((item, i, ar) => ar.indexOf(item) === i);
          if (distinctUnit && distinctUnit.length > 1) {
            this.message = 'Multiple unit found';
            return;
          }
          this.isLoading = false;
          this.data = this.helper.barLineComboDataMapper(res);
          this.xAxixValueData = res.map(axisValue => axisValue.dayOrMonth);
          this.deliveredQty = res.map(deliveredQtyValue => deliveredQtyValue.deliveredQty);
          this.costPercent = res.map(costPercentValue => costPercentValue.costPercentage);
          this.xAxixValueData = ['x'].concat(this.xAxixValueData);
          this.deliveredQty = ['data1'].concat(this.deliveredQty);
          this.costPercent = ['data2'].concat(this.costPercent);
          this.unit = res[0].deliveredQtyUnit;
          const lowestCost = Math.min(...this.data.barData);

          if (lowestCost >= 1000000000) {
            // Billion
            this.divisionNumber = 1000000000;
            this.signType = 'B';
          } else if (lowestCost >= 1000000) {
            // Million
            this.divisionNumber = 1000000;
            this.signType = 'M';
          } else if (lowestCost >= 1000) {
            // Thousand
            this.divisionNumber = 1000;
            this.signType = 'K';
          }
          this.generateChart();
        } else {
          this.message = 'Data not available.';
        }
      });
  }

  generateChart() {
    const thisObj = this;
    c3.generate({
      bindto: this.elRef.nativeElement.children[0].children[2],
      data: {
        x: 'x',
        columns: [
          this.xAxixValueData,
          this.deliveredQty,
          this.costPercent,
        ],
        names: {
          data1: 'Sum of Delivered Quantity',
          data2: 'Cost %'
        },
        axes: {
          data1: 'y',
          data2: 'y2'
        },
        type: 'bar',
        types: {
          data2: 'line',
        },
        colors: {
          data1: '#BF2A6E',
          data2: '#515CB4',
        },
      },
      point: {
        show: false
      },
      tooltip: {
        show: true,
        format: {
          title: (x: number) => (this.emitDataList &&
            (this.emitDataList.appliedFilterType === 'quarter' || this.emitDataList.appliedFilterType === 'year')
            ? monthnames[x - 1] : (x + ' ' + this.monthName + ' ')),
          value: (x: number) => x > 100 ? (x / thisObj.divisionNumber).toFixed(2) + thisObj.signType : x.toFixed(2) + '%'
        }
      },
      bar: {
        width: 5
      },
      axis: {
        y: {
          label: {
            text: 'Delivered Quantity',
            position: 'outer-middle'
          },
          tick: {
            format: ((x) => x / thisObj.divisionNumber + thisObj.signType)
          },
          show: true,
        },
        y2: {
          label: {
            text: 'Cost %',
            position: 'outer-middle'
          },
          show: true,
          tick: {

            format: (d: any) => d + '%'
          }
        },
        x: {
          label: {
            text: ((this.emitDataList &&
              (this.emitDataList.appliedFilterType === 'quarter' || this.emitDataList.appliedFilterType === 'year'))
              ? 'Month' : 'Date'),
            position: 'outer-center'
          },
          // type: 'category',
          // // tick: {
          // //   rotate: -20,
          // //   multiline: false
          // // },
          // categories: this.data.xAxisLabels
          show: true,
        }

      }
    });
  }

  showComboGraphInPopup() {
    this.dialog.open(BarLineComboChartPopupComponent, {
      width: '840px',
      height: '500px',
      data: {
        xAxisLabels: this.xAxixValueData,
        barData: this.deliveredQty,
        lineData: this.costPercent,
        monthName: this.monthName,
        divisionNumber: this.divisionNumber,
        signType: this.signType,
        unit: this.unit
      }
    });
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.deliveredQuantitySubscription) {
      this.deliveredQuantitySubscription.unsubscribe();
    }
  }

}
